import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './Image.module.scss';

export default function Image({ className, imageAlt, imageUrl, children }) {
  return (
    <div className={cn(styles.layout, className)}>
      <div className={styles.imageCol}>
        <img alt={imageAlt} src={imageUrl} className={styles.image} />
      </div>
      <div className={styles.textCol}>{children}</div>
    </div>
  );
}

Image.propTypes = {
  imageAlt: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
  children: PropTypes.node
};
